import { render } from "./DangerCard.vue?vue&type=template&id=f1807ae8&scoped=true"
import script from "./DangerCard.vue?vue&type=script&lang=js"
export * from "./DangerCard.vue?vue&type=script&lang=js"

import "./DangerCard.vue?vue&type=style&index=0&id=f1807ae8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1807ae8"]])

export default __exports__